/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_SovereignInputs */

const en_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const es_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const fr_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const de_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ja_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const zh_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ar_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const id_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const it_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ru_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const pt_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ko_badge_sovereign = /** @type {(inputs: Badge_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

/**
* | output |
* | --- |
* | "Sovereign" |
*
* @param {Badge_SovereignInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_sovereign = /** @type {((inputs?: Badge_SovereignInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_SovereignInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_sovereign(inputs)
	if (locale === "es") return es_badge_sovereign(inputs)
	if (locale === "fr") return fr_badge_sovereign(inputs)
	if (locale === "de") return de_badge_sovereign(inputs)
	if (locale === "ja") return ja_badge_sovereign(inputs)
	if (locale === "zh") return zh_badge_sovereign(inputs)
	if (locale === "ar") return ar_badge_sovereign(inputs)
	if (locale === "id") return id_badge_sovereign(inputs)
	if (locale === "it") return it_badge_sovereign(inputs)
	if (locale === "ru") return ru_badge_sovereign(inputs)
	if (locale === "pt") return pt_badge_sovereign(inputs)
	return ko_badge_sovereign(inputs)
});